export default "__VITE_ASSET__IgKOummu__"